import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { GuestList } from 'reservations/guests/components/GuestList';
import { MODIFY_GUESTS_SUBHEADER } from 'reservations/guests/constants';
import { useIsValidPartySize } from 'reservations/guests/hooks/useIsValidPartySize';

export const ModifyGuestsModal = () => {
  const validPartySize = useIsValidPartySize();
  const { open } = useModal();

  return (
    <BaseDrawer
      header="Remove guests"
      subheader={MODIFY_GUESTS_SUBHEADER}
      primaryButton={{
        label: 'DONE',
        disabled: !validPartySize,
        onClick: () => open(ModalType.BookingFields)
      }}
      dataTestId="modify-guests-modal"
      requireAuth
    >
      <GuestList validatePartySize />
    </BaseDrawer>
  );
};
